/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TriggerMessageTask
 */
export interface TriggerMessageTask {
    /**
     *
     * @type {number}
     * @memberof TriggerMessageTask
     */
    connectorIndex?: number;
    /**
     *
     * @type {string}
     * @memberof TriggerMessageTask
     */
    requestedMessage?: string;
}

/**
 * Check if a given object implements the TriggerMessageTask interface.
 */
export function instanceOfTriggerMessageTask(
    value: object,
): value is TriggerMessageTask {
    return true;
}

export function TriggerMessageTaskFromJSON(json: any): TriggerMessageTask {
    return TriggerMessageTaskFromJSONTyped(json, false);
}

export function TriggerMessageTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): TriggerMessageTask {
    if (json == null) {
        return json;
    }
    return {
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        requestedMessage:
            json["requestedMessage"] == null
                ? undefined
                : json["requestedMessage"],
    };
}

export function TriggerMessageTaskToJSON(
    value?: TriggerMessageTask | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        connectorIndex: value["connectorIndex"],
        requestedMessage: value["requestedMessage"],
    };
}
